const NAMESPACE = 'auth/';

export default {
  POST_CREATE_USER_TRIGGER: `${NAMESPACE}POST_CREATE_USER_TRIGGER`,
  POST_CREATE_USER_REQUEST: `${NAMESPACE}POST_CREATE_USER_REQUEST`,
  POST_CREATE_USER_SUCCESS: `${NAMESPACE}POST_CREATE_USER_SUCCESS`,
  POST_CREATE_USER_FAILURE: `${NAMESPACE}POST_CREATE_USER_FAILURE`,
  POST_LOGIN_USER_TRIGGER: `${NAMESPACE}POST_LOGIN_USER_TRIGGER`,
  POST_LOGIN_USER_REQUEST: `${NAMESPACE}POST_LOGIN_USER_REQUEST`,
  POST_LOGIN_USER_SUCCESS: `${NAMESPACE}POST_LOGIN_USER_SUCCESS`,
  POST_LOGIN_USER_FAILURE: `${NAMESPACE}POST_LOGIN_USER_FAILURE`,
  RESET_LOGIN_USER_STATE: `${NAMESPACE}RESET_LOGIN_USER_STATE`,
  PUT_NEWSLETTER_SUBSCRIPTION_REQUEST: `${NAMESPACE}PUT_NEWSLETTER_SUBSCRIPTION_REQUEST`,
  PUT_NEWSLETTER_SUBSCRIPTION_SUCCESS: `${NAMESPACE}PUT_NEWSLETTER_SUBSCRIPTION_SUCCESS`,
  PUT_NEWSLETTER_SUBSCRIPTION_FAILURE: `${NAMESPACE}PUT_NEWSLETTER_SUBSCRIPTION_FAILURE`,
  POST_SOCIAL_LOGIN_TRIGGER: `${NAMESPACE}POST_SOCIAL_LOGIN_TRIGGER`,
};
